import axios from 'axios';
import apiLogger from './apiLogger';
import { toast } from 'react-toastify';


export const resetNetworkErrorLock = () => {
  // no-op: kept for backward compatibility where this helper might be imported
};

export const axios_adapter = axios.create({
  // baseURL: BASE_URL_3,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    //'Content-Type': 'application/x-www-form-urlencoded',
  },
});

export const axios_adapter_without_header = axios.create({
  // baseURL: BASE_URL_3,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    //'Content-Type': 'application/x-www-form-urlencoded',
  },
});


axios_adapter.interceptors.request.use(
  (config) => {
    console.log("ENV => ", process.env.REACT_APP_ENV);
    /** AWS Identity Authentication Token */
    // const accessToken = sessionStorage.getItem("AccessToken");
    // if (accessToken) {
    //   config.headers.Authorization = `Bearer ${accessToken}`;
    // }

    console.log("config : ", config);
    const accessToken = localStorage.getItem('token');
    const idToken = localStorage.getItem('idToken');
    const tokenToUse = accessToken || idToken;

    if (tokenToUse) {
      config.headers['Authorization'] = `Bearer ${tokenToUse}`;
      console.log("API Header Token set", {
        using: accessToken ? 'accessToken' : 'idToken',
        tokenPreview: tokenToUse.slice(0, 10),
      });
    } else {
      console.warn("No auth token found in localStorage (keys: 'token' or 'idToken')");
    }

    return apiLogger.request(config);;
  },
  (error) => {
    return apiLogger.error(error);
  }
);

axios_adapter.interceptors.response.use(
  (response) => {
    //console.log("Response: ", response);
    return apiLogger.response(response);
  },
  (error) => {
    //console.log("Response error: ", error);
     const isNetworkError = !error?.response && (
      error?.message === 'Network Error' ||
      error?.code === 'ERR_NETWORK'
    );

     if (isNetworkError) {
      toast.error('Network error detected. Please check CORS or API availability.');
    } 
    else if (error?.response && error?.response?.status === 401) {
      const errPayload = {
        status: 401,
        url: error?.config?.url,
        responseData: error?.response?.data,
        timestamp: new Date().toISOString(),
      };
      try {
        window.localStorage.setItem('lastApiError', JSON.stringify(errPayload));
      } catch (e) {
        // ignore storage failures
      }
      console.error("401 Error - Token invalid or expired", errPayload);
      toast.error('Unauthorized (401) - check auth token.');
    }
    else {
      console.error("❌ API Error:", {
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
        data: error?.response?.data
      });
    }
    return apiLogger.error(error);
  }
);


/** AWS Identity Authentication Token Update using Refresh Token */
//  axios_adapter.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     if (
//       error.response?.status === 401 &&
//       !originalRequest._retry &&
//       sessionStorage.getItem("RefreshToken")
//     ) {
//       originalRequest._retry = true;
//       try {
//         const newAccessToken = await refreshToken();
//         axios.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
//         originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
//         return api(originalRequest); // Retry original request
//       } catch (refreshError) {
//         console.error("Redirecting to login...");
//         sessionStorage.clear();
//         window.location.href = "/login";
//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );